<template>
  <div class="main_view">
    <div class="examin_head">
      <el-form
        :label-position="labelPosition"
        label-width="90px"
        :model="formLabelAlign"
        ref="formLabelAlign"
      >
        <el-form-item label="任务名称：" prop="name">
          <el-input
            v-model.trim="formLabelAlign.name"
            placeholder="请输入任务名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务状态：" prop="account">
          <el-select
            v-model="formLabelAlign.status"
            @change="searchChang"
            placeholder="请选择"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in taskStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传时间：" prop="region">
          <el-date-picker
            v-model="viewTime"
            @change="searchChang"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          @click="searchData"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click="resetForm('formLabelAlign')"
          >重置</el-button
        >
      </div>
    </div>
    <div class="oper_box">
      <el-button id="guide-page-add" @click.stop="addEditOperation(0)">
        <i class="iconfont icon-action-add-hover"></i>新建任务
      </el-button>
    </div>
    <div class="examinee_form" v-loading="loading">
      <el-table
        ref="tabledata"
        :data="getData"
        style="width: 100%"
        :cell-class-name="stateColor"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="370">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                @click.stop="placement(scope.row)"
                type="text"
                size="small"
                >置顶</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="addEditOperation(1, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                :class="scope.row.isLock == 0 ? 'red' : 'green'"
                @click.stop="taskLockState(scope.row)"
                >{{ scope.row.isLock == 0 ? "暂停" : "恢复" }}任务</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="getRecord(scope.row, 'details')"
                >学习记录</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="handleClick(scope.row, 'details')"
                >统计分析</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="deleteTask(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <p>共有{{ total }}条记录，当前第{{ pageIndex }}/{{ pagesun }}页</p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="showpageindex"
          :page-size="formLabelAlign.eachPageNum"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import taskApi from "@/api/videoTask";

export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        name: "", //名称
        status: "", //任务状态
        examBeginDate: "", //时间
        examEndDate: "", // 结束时间
      },
      viewTime: "", // 查询时间
      name: "",
      loading: false,
      showpageindex: 1, //显示的索引盒子
      pageIndex: 1, //  当前页数
      pageSize: 15,
      total: 100,
      pagesun: "", //一共多少页
      pagesizesarr: [15, 30, 50, 100],
      getData: [],
      taskStatus: [
        {
          label: "未开始",
          value: "未开始",
        },
        {
          label: "进行中",
          value: "进行中",
        },
        {
          label: "已结束",
          value: "已结束",
        },
      ],
      formColumns: [
        {
          prop: "name",
          label: "任务名称",
          // width: "90px",
        },
        {
          prop: "taskStatus",
          label: "任务状态",
          // width: "90px",
        },
        {
          prop: "isLock2",
          label: "生效状态",
          // width: "90px",
        },
        {
          prop: "videoNum",
          label: "视频数量",
          width: "100px",
        },
        {
          prop: "stuNum",
          label: "学员数量",
          // width: "90px",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "180px",
        },
        {
          prop: "endTime",
          label: "到期时间",
          width: "180px",
        },
      ],
    };
  },
  props: ["cutcoms"],
  methods: {
    // 添加编辑
    addEditOperation(type, row) {
      if (type == 1) {
        // 编辑
        this.$parent.rowObj = row;
      }
      this.$parent.stateType = type;
      this.cutcoms(1);
    },
    // 搜索
    searchData() {
      this.loading = true;
      this.pageIndex = 1;
      this.$refs.tabledata.clearSelection(); // 清除勾选状态
      if (this.formLabelAlign.name) {
        this.name = this.formLabelAlign.name;
      } else {
        this.name = "";
      }
      this.getDatalist();
    },
    resetForm(formLabelAlign) {
      // 重置
      this.$refs[formLabelAlign].resetFields();
      this.name = "";
      this.formLabelAlign.examBeginDate = "";
      this.formLabelAlign.examEndDate = "";
      this.viewTime = "";
      this.loading = true;
      this.pageIndex = 1;
      this.showpageindex = 1;
      this.getDatalist();
    },
    // 任务置顶
    placement(row) {
      this.$confirm(
        `此操作将名称“${row.name}”任务置顶, 是否继续?`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          const obj = {
            taskID: row.taskId,
            hid: JSON.parse(localStorage.getItem("userlist")).hid,
          };
          const { data } = await taskApi.taskSort(obj);
          if (data.Status == 200) {
            this.$message({
              type: "success",
              message: "置顶成功!",
            });
            this.getDatalist();
          } else {
            this.$message.error(data.Data);
          }
        })
        .catch(() => {});
    },
    // 任务是否锁定
    taskLockState(row) {
      this.$confirm(
        `此操作将${row.isLock == 0 ? "暂停" : "恢复"}“${
          row.name
        }”任务, 是否继续?`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          const obj = {
            IsLock: row.isLock == 0 ? 1 : 0, // 锁定状态 0： 不锁定 1： 锁定
            taskID: row.taskId,
          };
          const { data } = await taskApi.taskLock(obj);
          if (data.Status == 200) {
            this.$message({
              type: "success",
              message: `任务${row.isLock == 0 ? "暂停" : "恢复"}成功!`,
            });
            this.getDatalist();
          } else {
            this.$message.error(data.Data);
          }
        })
        .catch(() => {});
    },
    // 删除任务
    deleteTask(row) {
      this.$confirm(`此操作将删除“${row.name}”任务, 是否继续?`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const obj = {
            taskID: row.taskId,
            hid: JSON.parse(localStorage.getItem("userlist")).hid,
          };
          const { data } = await taskApi.taskDel(obj);
          if (data.Status == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getDatalist();
          } else {
            this.$message.error(data.Data);
          }
        })
        .catch(() => {});
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.pageSize = val;
      this.getDatalist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.loading = true;
      this.getDatalist();
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      if (row.taskStatus === "未开始" && columnIndex === 2) {
        return "yellow";
      } else if (row.taskStatus === "已结束" && columnIndex === 2) {
        return "red";
      } else if (row.taskStatus === "进行中" && columnIndex === 2) {
        return "green";
      } else if (row.isLock == 1 && columnIndex === 3) {
        return "red";
      } else if (row.isLock == 0 && columnIndex === 3) {
        return "green";
      } else {
        return "";
      }
    },
    // chang搜索
    searchChang() {
      this.loading = true;
      if (this.viewTime == null) {
        this.formLabelAlign.examBeginDate = "";
        this.formLabelAlign.examEndDate = "";
      }
      this.getDatalist();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 获取列表
    async getDatalist() {
      this.loading = true;
      if (this.viewTime) {
        const time = JSON.parse(JSON.stringify(this.viewTime));
        this.formLabelAlign.examBeginDate = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.examEndDate = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      const obj = {
        name: this.name,
        status: this.formLabelAlign.status,
        beginTime: this.formLabelAlign.examBeginDate,
        endTime: this.formLabelAlign.examEndDate,
        pageNum: this.pageIndex - 1,
        pageSize: this.pageSize,
      };
      const { data } = await taskApi.taskList(obj);
      if (data.Status == 200) {
        this.getData = data.Data.list.map((item) => {
          item.isLock2 = item.isLock == 0 ? "开启中" : "暂停中";
          return item;
        });
        this.total = data.Data.total;
        setTimeout(() => {
          this.loading = false;
        });
      } else {
        this.$message.error(data.Data);
      }
    },
    // 学习记录
    getRecord(row) {
      this.$parent.rowObj = row;
      this.cutcoms(2);
    },
    //  统计分析
    handleClick(row) {
      this.$parent.rowObj = row;
      this.cutcoms(3);
    },
    // 删除
    deletelist() {},
  },
  activated() {
    this.getDatalist();
  },
};
</script>

<style lang="scss" scoped>
.main_view {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  min-height: 780px;
}
.examin_head {
  padding: 30px 24px 10px 30px;
  //  background-color: #64b5ff;
  display: flex;
  // justify-content: space-between;
  border-bottom: 1px solid rgba(231, 231, 231, 0.774);
  .el-form {
    display: flex;
  }
  .query_btn {
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}
.red {
  color: #ff0000 !important;
}
.green {
  color: #00a870 !important;
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .green .cell {
  color: #00a870 !important;
}
::v-deep .el-table .yellow .cell {
  color: #ed7b2f !important;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}
.examinee_form {
  min-height: 560px;
  padding: 24px;
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.el-button--text {
  font-size: 16px;
}
::v-deep .cell {
  text-align: center;
}
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 120px;
  }
  .el-button:nth-child(2) {
    background: #ee6717;
    width: 88px;
  }

  .el-button:nth-child(3) {
    background: #e54d4d;
    width: 104px;
    span > i {
      font-size: 16px !important;
      margin-right: 5px;
    }
  }
}
</style>